var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.375C18.4722 8.26389 20.4167 11.4236 23.3334 13.8542C26.25 16.2847 27.7084 18.9583 27.7084 21.875C27.7084 24.5824 26.6328 27.1789 24.7184 29.0934C22.804 31.0078 20.2074 32.0833 17.5 32.0833C14.7926 32.0833 12.1961 31.0078 10.2816 29.0934C8.3672 27.1789 7.29169 24.5824 7.29169 21.875C7.29169 20.2973 7.8034 18.7622 8.75002 17.5C8.75002 18.4669 9.13413 19.3943 9.81786 20.078C10.5016 20.7617 11.4289 21.1458 12.3959 21.1458C13.3628 21.1458 14.2901 20.7617 14.9738 20.078C15.6576 19.3943 16.0417 18.4669 16.0417 17.5C16.0417 14.5833 13.8542 13.125 13.8542 10.2083C13.8542 8.26389 15.0695 6.31944 17.5 4.375Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.661ce9f18dde5274506fce9a58b0ae1f.svg";
export { ForwardRef as ReactComponent };